const defaultContent = {
  // ── Theme ─────────────────────────────────────────────────────────────────
  theme: {
    navy:       "#1B3F8B",
    navyDark:   "#122B62",
    coral:      "#F0876A",
    mint:       "#4BAE95",
    yellow:     "#F5C518",
    cream:      "#FEFCF6",
    cardRadius: 24,
    cardPaddingV: 32,
    cardPaddingH: 28,
  },

  // ── Global Contact ────────────────────────────────────────────────────────
  contact: {
    email:        "minimuslimsnest@gmail.com",
    whatsapp:     "+92 339 000 2106",
    whatsappLink: "https://wa.me/923390002106",
    location:     "Nawab Town, Lahore",
    address:      "Nawab Town, Lahore, Punjab, Pakistan",
    hours:        "Mon–Fri: 9:00 AM – 1:00 PM",
  },

  // ── Navbar ────────────────────────────────────────────────────────────────
  navbar: {
    brand:   "MINI MUSLIMS NEST",
    tagline: "PRESCHOOL & AFTERSCHOOL CLUB",
    ctaText: "Book a Visit",
  },

  // ── Footer ────────────────────────────────────────────────────────────────
  footer: {
    brand:       "MINI MUSLIMS NEST",
    yearTag:     "SINCE 2024",
    description: "Pakistan's first mommy-inclusive preschool. Where roots grow deeper than grades.",
    joinHeading: "Join Us",
    ctaText:     "Book a Visit",
    copyright:   "Mini Muslims Nest — Lahore, Pakistan",
  },

  // ── Exit Popup ────────────────────────────────────────────────────────────
  popup: {
    enabled:          true,
    heading:          "One Moment Before You Leave",
    subheading:       "Let's talk about your child's future.",
    body:             "Our spots are limited. If Mini Muslims Nest resonates with your heart, reach out — we'd love to meet your family.",
    namePlaceholder:  "Your Name",
    phonePlaceholder: "Phone or WhatsApp Number",
    msgPlaceholder:   "Tell us a little about your child…",
    ctaText:          "Send Message",
    successMsg:       "JazakAllah Khair! We'll be in touch with you very soon.",
  },

  // ── Home — Hero ───────────────────────────────────────────────────────────
  homeHero: {
    badge:       "Pakistan's First Mommy-Inclusive Preschool",
    badgeIcon:   "✨",
    brandTag:    "Since 2024 · Lahore",
    headingLine1:"Where Roots",
    headingLine2:"Grow Deeper",
    headingLine3:"Than Grades.",
    subPara1:    "The first school of its kind — where mothers stay alongside their children, growing together. A Mommy & Me Preschool for children aged 4 to 7, where every child moves forward when they are genuinely ready, not when a calendar says so.",
    tagline:     "Reggio Emilia · Waldorf · Montessori · Islamic Foundation",
    cta1Text:    "Book a Visit",
    cta2Text:    "See the Vision →",
    scrollLabel: "Scroll to begin the journey",
  },

  homeHeroStats: [
    { number: "4",  suffix: "–7", label: "Years Old" },
    { number: "9",  suffix: " AM", label: "School Starts" },
    { number: "15", suffix: "",   label: "Children Max" },
    { number: "1",  suffix: "st", label: "Of Its Kind" },
  ],

  // ── Home — Vision ─────────────────────────────────────────────────────────
  homeVision: {
    badge:       "⊹ A New Kind of School ⊹",
    heading1:    "This Is Not Just a School.",
    heading2:    "This Is a Vision.",
    subQuote:    "And like every vision worth building — it will take a great deal of courage, trust, and intent — from us, and from you.",
    bottomQuote: "This is the first school of its kind — where mothers do not leave at the gate.",
    bottomBody:  "They walk in, sit in, and grow in. Because the strongest tarbiyah a child can receive is watching their mother seek knowledge in the very same room.",
  },

  homeVisionPillars: [
    {
      letter: "C", word: "Courage", color: "#F0876A",
      tagline: "To stand against the tide.",
      body: "Courage to say no to the rat race. Courage to let a 4-year-old be a 4-year-old. Courage to choose depth over speed, character over scores, and Deen over the world's measurements of success. This school is for parents brave enough to walk a different road.",
      symbol: "🦁",
    },
    {
      letter: "T", word: "Trust", color: "#4BAE95",
      tagline: "In your child. In Allah. In the process.",
      body: "Trust that your child has their own rhythm — and it is not behind anyone's. Trust that the seeds you plant today bear fruit you may not see for years. Trust that slowness is not failure. Trust in the design of the One who created your child.",
      symbol: "🌱",
    },
    {
      letter: "I", word: "Intent", color: "#1B3F8B",
      tagline: "Niyyah is the soil everything grows in.",
      body: "Every choice here is intentional — the start time, the absence of uniforms, the mother in the room. Nothing is by accident. We ask families to bring the same intent. This is not enrolment. It is a covenant — to raise a child the way Allah meant for them to be raised.",
      symbol: "🤲",
    },
  ],

  // ── Home — Philosophy ─────────────────────────────────────────────────────
  homePhilosophy: {
    badge:    "Our Belief",
    heading1: "This School Is",
    heading2: "Not For Every Family.",
    quote:    "We do not believe that childhood success should be measured by how early a child starts reading or how quickly they are pushed through academic milestones.",
    body:     "Our focus is not on producing children who perform impressively on command, yet struggle to understand themselves, manage their emotions, or live their Deen with confidence. Our priority is to strengthen their roots.",
    callout:  "If the school doesn't exist — we build it.",
  },

  homePhilosophyCards: [
    { icon: "🌱", title: "Not For",        body: "Parents who want their 3-year-old reading chapter books. Families chasing rankings. Those who view separation anxiety as a weakness to overcome." },
    { icon: "🌟", title: "Perfectly For",  body: "Parents courageous enough to question conventional norms. Families who understand that a child who spends 18 months truly mastering something is ahead of the child who rushed through it in 6. Homeschooling families seeking structured community." },
    { icon: "🕌", title: "Our Foundation", body: "Islam is not one option among many here. It is the foundation through which children understand themselves and the world. Everything else grows from that root." },
  ],

  // ── About Page ────────────────────────────────────────────────────────────
  about: {
    heroBadge:    "Meet Our Founder",
    heroHeading:  "Born from a Mother's Courage.",
    heroSub:      "Mini Muslims Nest began not as a business plan — but as a prayer. A mother's prayer that somewhere, somehow, there would be a school that understood what truly mattered.",
    storyHeading: "We Couldn't Find the Right School. So We Built It.",
    storyBody1:   "We looked around and saw a world of schools rushing children through milestones — reading at 3, writing at 4, competing at 5. We saw mothers dropping their children at gates and driving away — leaving behind the most sacred years of their child's life.",
    storyBody2:   "We saw Deen treated as a subject on a timetable. We saw children who could recite perfectly but had no idea what they were saying, or why. So in 2024, we opened the doors to something that had never existed before in Pakistan.",
    storyQuote:   "If the school doesn't exist — we build it.",
    missionQuote: '"To raise a generation of children who know who they are, where they come from, and what they are here to do — as Muslims and as human beings."',
    missionSub:   "Not to produce children who perform impressively on command — but to nurture children who are deeply rooted, emotionally whole, spiritually alive, and genuinely ready to carry the amanah of being Allah's khalifah on Earth.",
  },

  aboutValues: [
    { icon: "🕌", color: "#F5C518", title: "Islamic Foundation", body: "Islam is not a subject here — it is the lens through which every experience is understood. Aqeedah, Quran, Seerah, and adab are woven into every single moment of the day." },
    { icon: "🌱", color: "#4BAE95", title: "Child-Led Learning", body: "Every child has their own rhythm. We do not rush, compare, or push. We observe, support, and celebrate each child's unique pace of growth — knowing it is perfect." },
    { icon: "👩‍👧", color: "#F0876A", title: "Mother's Presence",  body: "The mother is not dropped at the gate — she walks in. She sits, learns, and grows alongside her child. This has never existed in Pakistan before. It exists here." },
    { icon: "🎯", color: "#8B6BE8", title: "Intentional Design", body: "Every choice — the 9 AM start, no uniforms, the mothers in the room — is intentional. Nothing here is by accident. Everything serves the child and family." },
  ],

  aboutDifferences: [
    { icon: "🤲", title: "Mothers Stay",     body: "In every other preschool, the mother's role ends at the gate. At Mini Muslims Nest, the gate is the beginning. You walk in, sit in, and grow in — together with your child." },
    { icon: "⏰", title: "Starts at 9 AM", body: "Calm mornings belong to the family. Children arrive fed, rested, and ready — not rushed or stressed. We believe the morning is sacred family time." },
    { icon: "📚", title: "No Homework",      body: "Learning lives inside these walls. We do not send work home to steal your family evenings. The evening belongs to the dinner table and quiet moments together." },
    { icon: "👕", title: "No Uniforms",      body: "Four simple clothing sets, rotated weekly. Character matters here — not appearance. What your child wears will never be a topic of conversation at MMN." },
    { icon: "🕐", title: "Child's Own Pace", body: "Some children master something in 6 months. Others take 18. Both are completely right. We never push a child on our schedule. We follow theirs." },
    { icon: "🌙", title: "Deen First",       body: "Islam is not a period on the timetable. It is the beginning of every day, the lens through every lesson, and the heartbeat of this entire school." },
  ],

  // ── Programs Page ─────────────────────────────────────────────────────────
  programs: {
    heroBadge:        "What We Offer",
    heroHeading:      "Programs Designed for Whole Children.",
    heroSub:          "A micro school built around one belief: a child is not a grade. They are a spirit, a mind, a heart, a body, and a pair of hands.",
    preschoolBadge:   "Ages 4 – 7",
    preschoolHeading: "The Preschool Programme",
    preschoolSub:     "Every subject is taught, but never in isolation — each one is woven into one of five dimensions of who your child is, as Allah created them.",
    pedagogyBadge:    "How We Teach",
    pedagogyHeading:  "Three Approaches. One Foundation.",
    pedagogySub:      "Each pedagogy contributes something specific. None of them are the foundation. Islam is the foundation.",
    specialBadge:     "Specialist Programmes",
    specialHeading:   "Beyond the Classroom",
    specialSub:       "Because some things cannot be learned from a textbook.",
    afterschoolBadge:   "Ages 6 – 12",
    afterschoolHeading: "The Afterschool Club",
    afterschoolSub:     "For children who need a safe, enriching, Islamic space after school hours.",
  },

  programsPillars: [
    { icon: "🌙", color: "#1B3F8B", title: "Ruh — Spirit",   body: "Every day begins and ends with Allah. Quran is heard, felt, and loved before it is memorised. Aqeedah is not a subject — it is the lens through which children see the whole day." },
    { icon: "🧠", color: "#F0876A", title: "Aql — Mind",     body: "English, Urdu, and Arabic woven through every activity. Mathematics begins with hands, never pencils. Science is the daily question: what did Allah make, and how does it work?" },
    { icon: "💚", color: "#4BAE95", title: "Qalb — Heart",   body: "Feelings are understood, not managed. Children build vocabulary for their inner world in three languages. Empathy is practised, not taught from a poster." },
    { icon: "🌿", color: "#7BAF3E", title: "Jism — Body",    body: "Children spend meaningful time outdoors every week. They cook, move, dig, and carry. The body is an Amanah from Allah — we treat it that way." },
    { icon: "🤲", color: "#8B6BE8", title: "Yadayn — Hands", body: "Children make things. They cook their own snack, care for their space, and create through clay and paint. Every practical task teaches patience and gratitude." },
  ],

  programsPedagogy: [
    { icon: "🎨", color: "#F0876A", title: "Reggio Emilia", sub: "100 Languages of the Child",
      points: ["Child-led, self-paced learning", "Environment as the third teacher", "Documentation honours each child's journey", "Curiosity is never interrupted"] },
    { icon: "📖", color: "#1B3F8B", title: "Waldorf",       sub: "Storytelling + Seerah",
      points: ["Stories before screens, imagination before instruction", "Prophets' stories replace fairy-tale archetypes", "Seasonal rhythms follow the Hijri calendar", "Handwork builds concentration and care"] },
    { icon: "🧩", color: "#4BAE95", title: "Montessori",    sub: "Prepared Environment",
      points: ["Concrete before abstract — hands before pencils", "Freedom within limits grounded in Islamic adab", "Practical life as ibadah (wudu, folding, serving)", "Children choose their work within a prepared space"] },
  ],

  programsSpecial: [
    { icon: "🌳", color: "#F0876A", title: "Outdoor Field Trips",
      quote: '"Teach your children swimming, archery, and horse riding." — The Prophet ﷺ',
      body: "Regular trips beyond the classroom — farm visits, mall visits, horse riding, and more, chosen to fit what the children are learning that term. Real-world exposure, confidence, and courage — built outside these walls, not just in a room." },
    { icon: "🧠", color: "#1B3F8B", title: "Child Psychologist",
      quote: "Behavioural development is monitored — not just observed.",
      body: "A child psychologist conducts play-based developmental checks with the children. Concerns are caught early. Reports go to parents. We do not wait for problems to become crises." },
    { icon: "🥗", color: "#4BAE95", title: "Nutritionist",
      quote: "The brain of a hungry or sugar-flooded child cannot absorb Quran.",
      body: "A paediatric nutritionist sees every child at enrolment and stays involved in their care. Personalised plans in Urdu and English. Our snack policy is nutritionist-written and non-negotiable." },
  ],

  // ── For Mothers Page ──────────────────────────────────────────────────────
  forMothers: {
    heroBadge:       "✦ The First Of Its Kind ✦",
    heroHeading1:    "You Don't",
    heroHeading2:    "Drop Off and",
    heroHeading3:    "Leave.",
    heroSub:         "At Mini Muslims Nest, the mother's journey begins the moment she walks through the door — alongside her child, not behind it.",
    whyHeading1:     "In Every Other School,",
    whyHeading2:     "The Gate Is the End.",
    whyBody1:        "The mother drops off. The gate closes. She drives away — leaving behind the most sacred years of her child's life, handed to strangers.",
    whyBody2:        "We refused to accept that. Because the research is clear, the Islamic tradition is clear, and every mother's heart knows it: the first years of a child's life are shaped most profoundly by the mother's presence — not her absence.",
    whyCallout:      "At Mini Muslims Nest, the gate is the beginning.",
    dayBadge:        "A Glimpse, Not a Guarantee",
    dayHeading:      "What a Day Might Look Like",
    programsBadge:   "What Awaits You",
    programsHeading: "Your Journey With Us",
    programsSub:     "You come for your child. You stay for yourself. You leave transformed.",
  },

  mothersJourney: [
    { step: "6:30 AM",  label: "Morning at Home",  body: "The morning belongs to your family. Wake up without a rush. Make breakfast together. Pray Fajr together. Arrive calm." },
    { step: "9:00 AM",  label: "Walk in Together", body: "You and your child enter the Nest together. No separation anxiety — because there is no separation. You are both here." },
    { step: "9:15 AM",  label: "Children's World", body: "Your child begins their day — Quran, exploration, language, handwork. You can see, hear, and be near." },
    { step: "9:30 AM",  label: "Mothers' Circle",  body: "You join your circle. Today: a Tadabbur session on Surah Al-Baqarah. Or a workshop on conscious discipline. Or just connection." },
    { step: "12:30 PM", label: "Leave Together",   body: "You and your child leave together. You have both grown today. The car ride home is already different." },
  ],

  mothersProgrammes: [
    { icon: "📖", color: "#F5C518", title: "Friday Halaqa",    tag: "Weekly",
      body: "Every Friday, mothers gather for Tafseer and Tadabbur — not a lecture, but a living circle of reflection. We open the Quran together, sit with its meaning, and carry it home. Children may observe quietly." },
    { icon: "💆", color: "#F0876A", title: "Parent Coaching",  tag: "Ongoing",
      body: "Sessions with trained coaches covering anger management, conscious parenting, time management, and emotional regulation. A mother who is growing creates a home where growth is natural." },
    { icon: "🤝", color: "#4BAE95", title: "The Mother Circle", tag: "Daily",
      body: "A daily gathering running alongside the children's morning programme. Discussion, practical workshops, and a community of women growing in the same direction at the same time." },
    { icon: "🌱", color: "#8B6BE8", title: "HT4 Framework",   tag: "Term-based",
      body: "The same four-pillar framework our teachers train on — Holistic Teaching, Tarbiyah, Transformation, Tadabbur — with modules built just for mothers. You do not just bring your child here to grow. You grow here too." },
  ],

  // ── Admissions Page ───────────────────────────────────────────────────────
  admissions: {
    heroBadge:       "Join the Nest",
    heroHeading:     "Is This the Right School for Your Family?",
    heroSub:         "We do not accept every family — and we are honest about that. We accept families who are ready to walk a different road.",
    processHeading:  "The Enrolment Process",
    reqHeading:      "What We Ask of Families",
    faqHeading:      "Common Questions",
    notForHeading:   "Not For You If…",
    perfectForHeading:"Perfectly For You If…",
  },

  admissionsNotFor: [
    "You want your child reading and writing immediately",
    "You are looking for a drop-off school where you leave",
    "You believe faster is always better",
    "You see Deen as optional or supplementary",
  ],

  admissionsPerfectFor: [
    "You believe childhood is not a race",
    "You are ready to be present and grow alongside your child",
    "You understand that roots matter more than results",
    "Islam is the foundation of your home, not just a subject",
  ],

  admissionsProcess: [
    { step: "01", icon: "📝", color: "#F0876A", title: "Application & Screening of Parents", body: "We start with the parents, not the paperwork. A conversation to understand your family, your values, and whether there is real alignment." },
    { step: "02", icon: "📋", color: "#1B3F8B", title: "Official Procedures",               body: "Admission, payment, and documentation — handled clearly and without surprises, once alignment is confirmed." },
    { step: "03", icon: "🌱", color: "#4BAE95", title: "Mothers' Mandatory Training",        body: "Before your child ever enrols, mothers complete our training. It is non-negotiable — you walk in prepared, not just present." },
    { step: "04", icon: "🧒", color: "#8B6BE8", title: "Child's Diagnostic Assessment",      body: "The final step — understanding exactly where your child is starting from, so their pace, not a calendar, decides the plan." },
  ],

  admissionsReqs: [
    "Child is between 4 and 7 years old",
    "Mother is available to be present during school hours (this is non-negotiable — it is central to what we are)",
    "Family is aligned with the Islamic foundation of the school",
    "Parents understand and accept the child-paced, no-rush approach",
    "Families are committed to the full programme — not looking for a drop-off service",
  ],

  admissionsFaqs: [
    { q: "What age does my child need to be?",            a: "We accept children from 4 years old up to 7. We do not accept children younger than 4 — emotional readiness cannot be scheduled, and we will not pretend otherwise." },
    { q: "Does the mother have to be there every day?",   a: "Yes. This is not optional — it is central to what Mini Muslims Nest is. The mother's presence is the programme. If this is not possible, we are unfortunately not the right school for your family right now." },
    { q: "What if my child is already at another school?",a: "We welcome families transitioning. We have a gentle onboarding period for children who are used to different environments." },
    { q: "Do you follow a formal curriculum?",            a: "Yes — we follow curricula aligned with international standards, taught through Reggio Emilia, Waldorf, and Montessori approaches, all within an Islamic framework. It isn't a rigid syllabus delivered by rote, but there is deep structure and intentional planning behind every lesson." },
    { q: "Is there homework?",                            a: "No. Learning lives inside these walls. We believe family evenings belong to the family — not to a schoolbag." },
    { q: "What are your fees?",                           a: "Fees are discussed during the family meeting and depend on the programme chosen. We ask that you come speak with us first — because the conversation matters more than the number." },
    { q: "Do you accept children with special needs?",    a: "We consider each family individually. Please reach out and share more about your child — we will always respond with honesty and care." },
  ],

  // ── Contact Page ──────────────────────────────────────────────────────────
  contactPage: {
    heroBadge:          "Get in Touch",
    heroHeading:        "We'd Love to Meet You.",
    heroSub:            "Whether you have a question, want to book a visit, or just want to know more — our door is open.",
    formHeading:        "Send Us a Message",
    namePlaceholder:    "Your Name",
    phonePlaceholder:   "WhatsApp Number",
    messagePlaceholder: "Your message…",
    dropdownLabel:      "I want to…",
    submitText:         "Send via WhatsApp",
  },

  contactDropdownOptions: [
    "Book a school visit",
    "Learn more about the programme",
    "Ask about admissions",
    "Something else",
  ],
};

export default defaultContent;
